import * as React from "react";
const SvgBrandingWatermark = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M23 3H1v18h22V3zm-2 16h-9v-6h9v6z",
  fill: "currentColor"
}));
export default SvgBrandingWatermark;